import { useEffect, useState } from "react";

/*
 * FinvisePageNavigation
 * Drop-in replacement for components/PageNavigation, restyled to the index_16
 * light theme. Same prop contract & behaviour:
 *   page, maxPage, previousPage, nextPage, numberPageClick(pageNumber)
 * Rendered inside .finvise-portal so the scoped .fv-pager styles apply.
 * The numbered-window logic reproduces PageNavigationCenterButtons behaviour
 * (first / last always shown, a window around the current page, ellipses).
 */
const FinvisePageNavigation = (props) => {
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);

    const previousPage = props.previousPage;
    const nextPage = props.nextPage;
    const numberPageClick = props.numberPageClick;

    useEffect(() => {
        setPage(props.page || 1);
        setMaxPage(props.maxPage || 1);
    }, [props.page, props.maxPage]);

    // windowed page list: 1 … (p-1) p (p+1) … max
    const buildPages = () => {
        const out = [];
        if (maxPage <= 7) {
            for (let i = 1; i <= maxPage; i++) out.push(i);
            return out;
        }
        const push = (v) => out.push(v);
        push(1);
        if (page > 3) push("…");
        const start = Math.max(2, page - 1);
        const end = Math.min(maxPage - 1, page + 1);
        for (let i = start; i <= end; i++) push(i);
        if (page < maxPage - 2) push("…");
        push(maxPage);
        return out;
    };

    const Chevron = ({ left }) => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
             strokeLinecap="round" strokeLinejoin="round"
             style={left ? undefined : { transform: "rotate(180deg)" }}>
            <path d="M15 18l-6-6 6-6" />
        </svg>
    );

    return (
        <div className="fv-pager">
            <button className="prev" onClick={previousPage} disabled={page <= 1}>
                <Chevron left /> Previous
            </button>

            {buildPages().map((p, i) =>
                p === "…" ? (
                    <span className="gap" key={"g" + i}>…</span>
                ) : (
                    <button
                        key={p}
                        className={p === page ? "active" : undefined}
                        onClick={() => numberPageClick(p)}
                    >
                        {p}
                    </button>
                )
            )}

            <button className="next" onClick={nextPage} disabled={page >= maxPage}>
                Next <Chevron />
            </button>
        </div>
    );
};

export default FinvisePageNavigation;
